// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__4IzAS","footer__icon":"Footer_footer__icon__H6aAo","footer__btn":"Footer_footer__btn__ioiyc"};